import set_user_id from './set_user_id';
import set_user_data from './set_user_data';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
    set_user_id,
    set_user_data
});

export default rootReducer;